
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuNoodleStandTokyoMenuNoodlestandMenuTopImage } from "@src/constants/images";
import { meta as noodleStandTokyoPageMeta } from "./noodle_stand_tokyo.mdx";
export const meta = {
  path: "/media/harajuku/noodle_stand_tokyo_menu",
  title: "【テレビ出演多数】原宿ラーメン「ヌードルスタンド東京」のメニューを公開！",
  description: "ラーメン激戦区の原宿で、珍しいメニューが食べられるお店として人気の「ヌードルスタンド東京」のメニューをご紹介します。メニューの中でも、まぜそばやラーメンといった「ヌードルスタンド東京」主力のメニューをご紹介させていただきます。",
  topImg: harajukuNoodleStandTokyoMenuNoodlestandMenuTopImage,
  author: murakamiMasanori,
  tags: ["ラーメン", "有名店", "おしゃれな内装", "あっさり", "人気店", "お店の紹介", "1人メシ", "メニュー詳細"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ラーメン激戦区の原宿で、珍しいメニューが食べられるお店として人気の「ヌードルスタンド東京」。`}</p>
    <p>{`普通のラーメン店では想像できないようなメニューが揃っています。ラーメン屋なのにまぜそばメニューが人気だったり、ラーメンなのにココナッツのラーメンメニューがあったりなど、「あれ？」って思うことがたくさんあります。`}</p>
    <p>{`そんな気になるメニューをこれからご紹介していきます。`}</p>
    <h2>{`テレビやメディアにひっぱりだこの名店`}</h2>
    <p>{`ヌードルスタンド東京はテレビ、メディア、YouTube などでよく特集されている人気のお店です。
2020 年 5 月には、フジテレビが主催する`}<strong parentName="p">{`鬼旨ラーメン GP でも`}</strong>{`取り上げられるなど、その勢いはとどまることを知りません。`}</p>
    <h2>{`メニュー：まぜそば`}</h2>
    <p><strong parentName="p">{`ラーメン屋なのにまぜそば！？`}</strong>{`と思う方も多いのではないでしょうか？
実は、ヌードルスタンド で一番人気のメニューがまぜそばなんです！
こういった意外性のあるメニューがたくさんあるのが、人気の秘密にもなっています！
そんな人気のメニューがこちら…`}</p>
    <h3>{`牛煮込みまぜそば （税込；950 円）`}</h3>
    <InstaImage postId="B6-uVdAAbxj" mdxType="InstaImage" />
    <p>{`どっさりとしたコシのある麺、グツグツと煮込まれた牛煮込み、ふわふわの温玉が乗っていてボリューム感のあるメニューになっています！
このメニューを見るだけでもお腹がへりますよね...!`}</p>
    <h3>{`２種類から選べるトッピング`}</h3>
    <p>{`真ん中に乗っている温玉は実は無料のトッピングメニューになっていて、`}<strong parentName="p">{`温玉`}</strong>{`か`}<strong parentName="p">{`タルタル`}</strong>{`のどちらか選無ことができます！
どちらもつけたい方は、追加料金を払うと　ダブルトッピングで食べられますのだそう...`}</p>
    <p>{`ちなみに僕は二種類をトッピングしました！`}</p>
    <h4>{`温玉乗せ`}</h4>
    <InstaImage postId="B9qYxlxApE5" mdxType="InstaImage" />
    <h4>{`タルタル乗せ`}</h4>
    <InstaImage postId="BV4TkynhGOc" mdxType="InstaImage" />
    <h4>{`パクチーもトッピング！？`}</h4>
    <p>{`牛煮込みのしっかりした味付けに、パクチーの風味が絶妙にマッチするんです！
トッピングメニューとして、パクチーが苦手ではない人は、チャレンジしてみてください！`}</p>
    <hr></hr>
    <h2>{`メニュー：煮干ラーメン`}</h2>
    <p>{`ヌードルスタンドの一番ベーシックなメニューが、魚介系のラーメンの一つである`}<strong parentName="p">{`煮干しラーメン`}</strong>{`です！
煮干しがふんだんに使われた香りのあるダシに、化学調味料が不使用の素材にこだわった具材や麺をご紹介させていただきます。`}</p>
    <h3>{`KUROSHIO 煮干ラーメン（税込；850 円）`}</h3>
    <p>{`ダシの味は、`}<strong parentName="p">{`塩`}</strong>{`か`}<strong parentName="p">{`醤油`}</strong>{`のどちらかを選べるようになっています！
`}<strong parentName="p">{`KUROSHIO`}</strong>{`の名前の由来は、黒潮の影響をうけた自然豊かな千葉県産の食材を豊富に使用していることからこの名前がついているそうなんです！`}</p>
    <p>{`九十九里の煮干を使ったダシに、柔らかな千葉県産肩ロースのチャーシューなど厳選素材を盛り込んだ煮干ラーメンです。`}</p>
    <h3>{`背脂 KUROSHIO 煮干ラーメン（税込；850 円）`}</h3>
    <InstaImage postId="B5sDeu9Adl4" mdxType="InstaImage" />
    <p>{`先ほどのメニュー同様、塩か醤油を選ぶことができます！
煮干しのコクのあるダシと、旨味が濃縮された背脂が合わさることで、食欲をそそるメニュー。
ガッツリとラーメンを食べたい方にはおすすめのメニューです！`}</p>
    <hr></hr>
    <h2>{`メニュー：ココナッツラーメン`}</h2>
    <p><strong parentName="p">{`ラーメンなのにココナッツ！？`}</strong>{`と思う方も多いと思いますが、ヘルシーなのにコクのある味わいが大人気で、女性や外国人の方に大人気のヘルシーなラーメンのメニューになっています。`}</p>
    <h3>{`COCONUT 味噌ラーメン（税込；1,100 円）`}</h3>
    <InstaImage postId="B8v9QFFhcKb" mdxType="InstaImage" />
    <p>{`スーパーフードとして注目されている BrownSugar1st.のココナッツオイルを使用した味噌ラーメンです！
まじりっけのないないココナッツと、白味噌なのに驚くほどヘルシーなメニューを味わってみてください。`}</p>
    <p>{`◼︎BrownSugar1st.について詳しく知りたい方はこちら ↓
`}<a parentName="p" {...{
        "href": "https://bs1stonline.com/"
      }}>{`https://bs1stonline.com/`}</a></p>
    <h4>{`麺が選べる！？`}</h4>
    <p>{`ヌードルスタンド ではヘルシーな`}<strong parentName="p">{`グルテンフリー麺`}</strong>{`も選んで食べることができます！
COCONUT 味噌ラーメンは、ローカーボ麺が使用されていて、そのままでもかなりヘルシーなラーメンになっていますが、ヘルシーなメニューで食べたい方にはグルテンフリーのメニューがおすすめです！`}</p>
    <h3>{`ヴィーガン COCONUT 味噌ラーメン（税込；1,100 円）`}</h3>
    <p>{`ソイミートをブレンドして作り上げているチャーシューを使った CCONUT 味噌ラーメン！
ヘルシーな味わいなのに、肉を一切使用していないこちらのメニューを求めて、多くの外国人や女性客が訪れています。
男女問わず、ヘルシーなラーメンを食べてみたい方、新しいラーメンメニューに挑戦してみたい方は、こちらのメニューがおすすめです。`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`ヌードルスタンド(Noodle Stand Tokyo)は、原宿駅の竹下口から`}<strong parentName="p">{`徒歩１分`}</strong>{`という好立地！
休日は人混みにつかまってしまうと、５分程度かかる可能性もありますが、比較的短い時間で到着できます。`}</p>
    <GoogleMap lat={35.672298} lng={139.7013333} mdxType="GoogleMap" />
    <h3>{`地下につながる入り口を探そう`}</h3>
    <p>{`ヌードルスタンドに到着しても「見つけられない」「場所が分からない！」といった方もたくさんいらっしゃるそうなので、こちらの外観を探してください。
こちらの外観を地下に下りていくとヌードルスタンドになります！`}</p>
    <InstaImage postId="BxjOxC8pJ8P" mdxType="InstaImage" />
    <h3>{`階段を降りると店の入り口を発見できます`}</h3>
    <p>{`バーのようなおしゃれな入り口を開けるとヌードルスタンドの店内になります！`}</p>
    <InstaImage postId="Bm9w0pDlO00" mdxType="InstaImage" />
    <h3>{`おわりに`}</h3>
    <p>{`ヌードルスタンドのまぜそばとラーメンについてご紹介してきましたが、いかがでしたでしょうか！？
ラーメンなのにまぜそばが一番人気のメニューだったり、ラーメンなのにヘルシーなココナッツラーメンのメニューがあったりと、驚きの連続だったと思います！
原宿でヌードルスタンドにお越しの際には、メニューをこちらのサイトで確認してから、お越しください！`}</p>
    <hr></hr>
    <p>{`関連記事`}</p>
    <LinkWithThumbnail meta={noodleStandTokyoPageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;